import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { CreateCountryProvider } from '../contexts';
import { CreateCountry } from '../containers';
import { PageContent } from '@core/ui';

export const CreateCountriesPage: FC = () => {
  const { id } = useParams<{ id?: string }>();

  return (
    <CreateCountryProvider id={id}>
      <PageContent>
        <CreateCountry />
      </PageContent>
    </CreateCountryProvider>
  );
};
